import { alpha } from '@mui/material/styles';
import { menuItemClasses } from '@mui/material/MenuItem';
import { gray } from '../ThemePrimitives';

export const datePickersCustomizations = {
  MuiPickersPopper: {
    styleOverrides: {
      paper: ({ theme }) => ({
        marginTop: 4,
        borderRadius: theme.shape.borderRadius,
        border: `1px solid ${alpha(theme.palette.divider, 0.4)}`,
        backgroundImage: 'none',
        background: alpha(theme.palette.background.paper, 0.98),
        backdropFilter: 'blur(8px)',
        padding: '4px',
        [`& .${menuItemClasses.root}`]: {
          borderRadius: theme.shape.borderRadius,
          margin: '2px 4px',
          padding: '6px 12px',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.04),
          },
          '&.Mui-selected': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
        },
        ...theme.applyStyles('dark', {
          background: alpha(gray[900], 0.98),
        }),
      }),
    },
  },
  MuiPickersArrowSwitcher: {
    styleOverrides: {
      spacer: { width: 16 },
      button: ({ theme }) => ({
        backgroundColor: 'transparent',
        color: theme.palette.text.secondary,
        borderRadius: theme.shape.borderRadius,
        padding: '4px',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&:active': {
          transform: 'scale(0.95)',
        },
        '&:focus-visible': {
          outline: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          outlineOffset: '2px',
        },
        ...theme.applyStyles('dark', {
          color: theme.palette.text.secondary,
        }),
      }),
    },
  },
  MuiPickersCalendarHeader: {
    styleOverrides: {
      switchViewButton: ({ theme }) => ({
        padding: '4px 8px',
        border: 'none',
        borderRadius: theme.shape.borderRadius,
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&:focus-visible': {
          outline: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          outlineOffset: '2px',
        },
      }),
      iconButton: ({ theme }) => ({
        borderRadius: theme.shape.borderRadius,
        padding: '4px',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&:focus-visible': {
          outline: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          outlineOffset: '2px',
        },
      }),
    },
  },
  MuiPickersMonth: {
    styleOverrides: {
      monthButton: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
        color: theme.palette.text.secondary,
        padding: theme.spacing(0.75),
        borderRadius: theme.shape.borderRadius,
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.primary.main,
          color: 'white',
          fontWeight: theme.typography.fontWeightMedium,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        },
        '&:focus': {
          outline: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          outlineOffset: '2px',
          backgroundColor: 'transparent',
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
          },
        },
        ...theme.applyStyles('dark', {
          color: theme.palette.text.secondary,
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
          '&.Mui-selected': {
            color: 'white',
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        }),
      }),
    },
  },
  MuiPickersYear: {
    styleOverrides: {
      yearButton: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
        color: theme.palette.text.secondary,
        padding: theme.spacing(0.75),
        borderRadius: theme.shape.borderRadius,
        height: 'fit-content',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.primary.main,
          color: 'white',
          fontWeight: theme.typography.fontWeightMedium,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        },
        '&:focus': {
          outline: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          outlineOffset: '2px',
          backgroundColor: 'transparent',
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
          },
        },
        ...theme.applyStyles('dark', {
          color: theme.palette.text.secondary,
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
          '&.Mui-selected': {
            color: 'white',
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        }),
      }),
    },
  },
  MuiPickersDay: {
    styleOverrides: {
      root: ({ theme }) => ({
        fontSize: theme.typography.body1.fontSize,
        color: theme.palette.text.secondary,
        padding: theme.spacing(0.5),
        borderRadius: theme.shape.borderRadius,
        width: 36,
        height: 36,
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: alpha(theme.palette.primary.main, 0.04),
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.primary.main,
          color: 'white',
          fontWeight: theme.typography.fontWeightMedium,
          '&:hover': {
            backgroundColor: theme.palette.primary.dark,
          },
        },
        '&.Mui-disabled': {
          opacity: 0.4,
          backgroundColor: 'transparent',
        },
        '&:focus': {
          outline: `2px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          outlineOffset: '2px',
          backgroundColor: 'transparent',
          '&.Mui-selected': {
            backgroundColor: theme.palette.primary.main,
          },
        },
        ...theme.applyStyles('dark', {
          color: theme.palette.text.secondary,
          '&:hover': {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
          },
          '&.Mui-selected': {
            color: 'white',
            backgroundColor: theme.palette.primary.main,
            '&:hover': {
              backgroundColor: theme.palette.primary.dark,
            },
          },
        }),
      }),
    },
  },
};
